<template>
  <component :is="tag" class="v-data">
    <slot v-bind="reactiveData"></slot>
  </component>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    tag: {
      type: String,
      default: "div"
    }
  },
  data() {
    return {
      reactiveData: {}
    };
  },
  created() {
    this.updateReactiveData(this.data);

    this.$watch("data", (newData, oldData) => {
      if (JSON.stringify(newData) !== JSON.stringify(oldData)) {
        this.updateReactiveData(newData);
      }
    });
  },
  methods: {
    updateReactiveData(data) {
      Object.keys(data).forEach(key => {
        this.$set(this.reactiveData, key, data[key]);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.v-data {
  &:is(li) {
    list-style: none;
    user-select: none;
    margin: 0;
  }
}
</style>
